export const useSxStyles = () => {
  const maxHeight = 'calc(100vh - 100px)';

  return {
    menu: {
      padding: 0,
      maxHeight,
    },
    columnsPanel: {
      maxHeight,
    },
  };
};
